import { getRouteApi } from '@tanstack/react-router';

export const vendorFundingsRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/vendors/vendorsLayout/fundings',
);

export const fundingTermsRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/vendors/$vendorId/fundings',
);

export const vendorCommunicationRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/vendors/vendor-communication/',
);
